// Simple in-file i18n dictionary for the SK/EN interface toggle.

export const STRINGS = {
  sk: {
    appTitle: "Persona DM Cockpit",
    appSubtitle: "Návrh odpovedí v tvojom štýle — Instagram DM asistent",
    langLabel: "Jazyk rozhrania",

    // Auth
    authOverline: "PRIHLÁSENIE",
    authTitle: "Prihlás sa do svojho cockpitu",
    emailLabel: "E-mail",
    passwordLabel: "Heslo",
    loginBtn: "Prihlásiť sa",
    logoutBtn: "Odhlásiť",
    authHint:
      "Prihlásenie ide cez tvoj Supabase projekt (email + heslo). Session sa uchováva bezpečne v prehliadači.",
    signedInAs: "Prihlásený ako",
    errorAuthEmptyFields: "Zadaj e-mail aj heslo.",
    errorAuthGeneric: "Prihlásenie zlyhalo.",
    successAuth: "Prihlásené",

    // Config panel
    configTitle: "Persona & pravidlá",
    configOverline: "KONFIGURÁCIA",
    personaName: "Meno persony",
    personaNamePh: "napr. Ella",
    toneStyle: "Tón & štýl",
    toneStylePh: "Ako píšeš, aký si dlhý, aký si teplý...",
    doRules: "DO (rob toto)",
    doRulesPh: "Pravidlá čo robiť...",
    dontRules: "DON'T (nerob toto)",
    dontRulesPh: "Pravidlá čo nikdy nerobiť...",
    funnelLink: "Funnel link",
    funnelLinkPh: "https://fanvue.com/tvoj-handle",
    languagesLabel: "Jazyky (info)",
    languagesPh: "napr. sk,en",
    savingSettings: "Ukladám...",
    settingsSaved: "Nastavenia uložené",
    settingsLoadError: "Nepodarilo sa načítať nastavenia",

    // API
    apiOverline: "OPENROUTER",
    apiKey: "OpenRouter API kľúč",
    apiKeyPh: "sk-or-v1-...",
    apiKeyHint:
      "Uloží sa do tvojho Supabase projektu (settings tabuľka). Backend má aj fallback v .env.",
    model: "Model",

    // Conversations
    convOverline: "KONVERZÁCIE (LEADY)",
    convTitle: "Konverzácie",
    convNewLabel: "Nový lead / kontakt",
    convNewLabelPh: "napr. @adamko_87 alebo John (IG)",
    convCountryPh: "krajina (voliteľné)",
    convTagsPh: "tagy, oddelené čiarkou",
    convCreateBtn: "Pridať",
    convEmpty: "Ešte nemáš žiadnu konverzáciu. Pridaj prvý lead vyššie.",
    convLoading: "Načítavam konverzácie...",
    convNotes: "Poznámky",
    convNotesPh: "Čokoľvek, čo si o ňom chceš pamätať...",
    convLabelRequired: "Label je povinný.",
    convCreated: "Konverzácia vytvorená",
    convDeleted: "Konverzácia zmazaná",
    convNotesSaved: "Poznámky uložené",
    convNoneSelected:
      "Nemáš vybranú konverzáciu — návrh sa vygeneruje, ale neuloží sa do histórie.",
    convActive: "Aktívna konverzácia",

    // Inbox
    inboxOverline: "SIMULOVANÝ INBOX",
    inboxTitle: "Prichádzajúca správa",
    incomingLabel: "DM od neho",
    incomingPh: "Vlož sem správu, ktorú ti napísal...",
    historyLabel: "Krátka história konverzácie (voliteľné)",
    historyPh: "THEM: Ahoj krásna\nME: Ahoj :)\nTHEM: čo robíš?",
    historyHint:
      "Formát riadka: THEM: ... alebo ME: ... — ak máš zvolenú konverzáciu, história z DB sa použije automaticky.",
    suggestBtn: "Navrhni odpoveď",
    suggestBtnLoading: "Premýšľam...",
    clearBtn: "Vyčistiť",

    // Output
    outputOverline: "NÁVRH ODPOVEDE",
    replyTitle: "Odpoveď v tvojom hlase",
    copyBtn: "Kopírovať",
    copied: "Skopírované",
    heatLabel: "HEAT",
    hotBadge: "HOT",
    warmBadge: "WARM",
    coldBadge: "COLD",
    detectedLang: "Jazyk",
    emptyOutput: "Zatiaľ žiadny návrh. Vlož správu a klikni \u201eNavrhni odpoveď\u201c.",

    // Toasts / errors
    errorGeneric: "Niečo sa pokazilo",
    errorNoMessage: "Vlož najprv prichádzajúcu správu.",
    errorNoKey: "Chýba OpenRouter API kľúč (Nastavenia alebo backend .env).",
    successCopied: "Odpoveď skopírovaná do schránky",

    // Footer
    footerNote:
      "Phase 1 · Supabase perzistencia · konverzačná pamäť · bez auto-odosielania",

    // Phase 2 — funnel
    funnelOverline: "FUNNEL / LINKDROP",
    funnelTitle: "Verejná landing page",
    funnelPublicUrl: "Verejná URL",
    funnelSlug: "Slug (URL cesta)",
    funnelSlugHint:
      "Malé písmená, čísla, pomlčka, podčiarknik. Napr. „ella\u201c → verejná stránka bude /f/ella.",
    funnelDisplayName: "Zobrazené meno",
    funnelBio: "Bio",
    funnelBioPh: "Krátky popis, jedna–dve vety...",
    funnelAvatar: "Avatar URL (voliteľné)",
    funnelSaveProfile: "Uložiť profil",
    funnelAnalytics: "Kliknutia",
    funnelTotal: "Spolu",
    funnelLast7: "7 dní",
    funnelLast30: "30 dní",
    funnelLinks: "Odkazy",
    funnelAddLink: "Pridať odkaz",
    funnelLinkTitlePh: "Fanvue, Telegram, Instagram, ...",
    funnelLinksEmpty:
      "Ešte žiadny odkaz. Pridaj napr. Fanvue, Telegram alebo Instagram.",
    funnelClicksLabel: "kliknutí",
    funnelSlugRequired: "Slug je povinný.",
    funnelLinkRequired: "Zadaj názov aj URL.",
    funnelProfileSaved: "Profil uložený",
    funnelLinkCreated: "Odkaz pridaný",
    funnelUrlCopied: "URL skopírovaná",
    inactive: "Skrytý",
    hide: "Skryť",
    show: "Zobraziť",
    saving: "Ukladám...",
    setAsAiFunnel: "Použiť ako AI funnel link",
    aiFunnelSet: "Nastavené ako AI funnel link",

    // Phase 4 — registration + soft gate
    authNoAccount: "Ešte nemáš účet?",
    registerOverline: "REGISTRÁCIA",
    registerTitle: "Vytvor si prístup",
    registerSubtitle: "Verejná registrácia · admin schvaľuje ručne",
    registerName: "Meno",
    registerReason: "Dôvod registrácie",
    registerReasonPh: "Napíš nám v pár vetách prečo chceš prístup...",
    registerSubmit: "Registrovať sa",
    registerAlreadyHave: "Už máš účet?",
    registerFillAll: "Vyplň všetky polia.",
    registerPwShort: "Heslo musí mať aspoň 8 znakov.",
    registerSuccess: "Registrácia prijatá",
    registerDoneTitle: "Ďakujeme! Registrácia prijatá.",
    registerDoneBody:
      "Účet bol vytvorený a čaká na schválenie adminom. Môžeš sa hneď prihlásiť, ale funkcie budú zamknuté kým admin schváli.",
    registerGotoLogin: "Prejsť na prihlásenie",
    pendingBannerTitle: "Účet čaká na schválenie",
    pendingBannerBody:
      "Tvoj účet čaká na schválenie. Funkcie sú zatiaľ zamknuté. Ozveme sa hneď ako to admin schváli.",
    bannedBannerTitle: "Účet bol zablokovaný",
    bannedBannerBody: "Prístup bol zamietnutý.",

    // Phase 3 — persona v2
    aboutMe: "O mne (About me)",
    aboutMePh: "Ako sa voláš, koľko máš, čím sa živíš, čo máš rada...",
    aboutMeHint:
      "AI použije tieto fakty, keď sa niekto opýta osobnú otázku. Nevymýšľa si nič naviac.",
    ageLabel: "Vek (voliteľné)",
    boundariesLabel: "Boundaries (čo NIKDY nerobiť)",
    boundariesPh: "Napr. nikdy neposielam nudes, nikdy neriešim medicínu...",
    transitionLabel: "Transition line (ako naviesť na link)",
    transitionPh:
      "Teaser jednou vetou, AI ju prepíše prirodzene tesne pred linkom.",

    // Rules engine
    rulesOverline: "PRAVIDLÁ FUNNELU",
    rulesTitle: "Kedy AI ponúka link",
    ruleMinMessages: "Min. správ pred linkom",
    ruleHeatThreshold: "Heat prah (0–100)",
    ruleCooldown: "Cooldown (počet správ)",
    ruleIntentTriggers: "Intent triggers (čiarkou)",
    ruleIntentTriggersPh: "nudes, private, content, pay, OF",

    // Reply settings
    replyOverline: "ŠTÝL ODPOVEDE",
    replyTitleSection: "Nastavenie odpovede",
    toneIntensity: "Intenzita tónu",
    toneSubtle: "Jemný",
    toneBalanced: "Vyvážený",
    toneBold: "Odvážny",
    replyLength: "Dĺžka odpovede",
    lenShort: "Krátka",
    lenMedium: "Stredná",
    lenLong: "Dlhá",
    emojiLevel: "Emoji",
    emojiNone: "Žiadne",
    emojiLight: "Málo",
    emojiModerate: "Stredne",
    languageMode: "Jazyk odpovede",
    langMirror: "Zrkadli prichádzajúci",
    langForceSk: "Vždy SK",
    langForceEn: "Vždy EN",

    // Image upload
    imageAttach: "Priloh obrázok (voliteľné)",
    imageAttachHint:
      "Ak ti pošle fotku, AI ju uvidí. Nikdy negeneruje explicitný obsah. Ak fotka obsahuje maloletú osobu v sexuálnom kontexte, žiadosť BLOKUJE.",
    imageAttachBtn: "Vybrať obrázok",
    imageRemove: "Odstrániť obrázok",
    imageAttached: "Obrázok pripojený",
    imageBlockedTitle: "Bezpečnostný blok",
    imageBlockedBody:
      "Žiadosť bola zablokovaná bezpečnostným pravidlom. Nič sa nevygenerovalo.",
    imageNoteLabel: "Poznámka k obrázku",
    linkIncluded: "Link vložený",
    linkNotIncluded: "Link NEvložený",
  },
  en: {
    appTitle: "Persona DM Cockpit",
    appSubtitle: "In-voice reply suggestions — Instagram DM assistant",
    langLabel: "Interface language",

    authOverline: "SIGN IN",
    authTitle: "Sign in to your cockpit",
    emailLabel: "Email",
    passwordLabel: "Password",
    loginBtn: "Sign in",
    logoutBtn: "Sign out",
    authHint:
      "Sign-in uses your Supabase project (email + password). Session is stored securely in your browser.",
    signedInAs: "Signed in as",
    errorAuthEmptyFields: "Enter both email and password.",
    errorAuthGeneric: "Sign-in failed.",
    successAuth: "Signed in",

    configTitle: "Persona & rules",
    configOverline: "CONFIGURATION",
    personaName: "Persona name",
    personaNamePh: "e.g. Ella",
    toneStyle: "Tone & style",
    toneStylePh: "How you write, how long, how warm...",
    doRules: "DO",
    doRulesPh: "Things to do...",
    dontRules: "DON'T",
    dontRulesPh: "Things to never do...",
    funnelLink: "Funnel link",
    funnelLinkPh: "https://fanvue.com/your-handle",
    languagesLabel: "Languages (info)",
    languagesPh: "e.g. sk,en",
    savingSettings: "Saving...",
    settingsSaved: "Settings saved",
    settingsLoadError: "Failed to load settings",

    apiOverline: "OPENROUTER",
    apiKey: "OpenRouter API key",
    apiKeyPh: "sk-or-v1-...",
    apiKeyHint:
      "Stored in your own Supabase project (settings table). Backend also supports .env fallback.",
    model: "Model",

    convOverline: "CONVERSATIONS (LEADS)",
    convTitle: "Conversations",
    convNewLabel: "New lead / contact",
    convNewLabelPh: "e.g. @adamko_87 or John (IG)",
    convCountryPh: "country (optional)",
    convTagsPh: "tags, comma-separated",
    convCreateBtn: "Add",
    convEmpty: "No conversations yet. Add your first lead above.",
    convLoading: "Loading conversations...",
    convNotes: "Notes",
    convNotesPh: "Anything you want to remember about him...",
    convLabelRequired: "Label is required.",
    convCreated: "Conversation created",
    convDeleted: "Conversation deleted",
    convNotesSaved: "Notes saved",
    convNoneSelected:
      "No conversation selected — reply will be generated but not saved to history.",
    convActive: "Active conversation",

    inboxOverline: "SIMULATED INBOX",
    inboxTitle: "Incoming message",
    incomingLabel: "DM from him",
    incomingPh: "Paste the message he sent you...",
    historyLabel: "Short conversation history (optional)",
    historyPh: "THEM: hey beautiful\nME: hey :)\nTHEM: what you up to?",
    historyHint:
      "Line format: THEM: ... or ME: ... — if a conversation is selected, DB history is used automatically.",
    suggestBtn: "Suggest reply",
    suggestBtnLoading: "Thinking...",
    clearBtn: "Clear",

    outputOverline: "SUGGESTED REPLY",
    replyTitle: "Reply in your voice",
    copyBtn: "Copy",
    copied: "Copied",
    heatLabel: "HEAT",
    hotBadge: "HOT",
    warmBadge: "WARM",
    coldBadge: "COLD",
    detectedLang: "Language",
    emptyOutput: "No suggestion yet. Paste a message and click \u201cSuggest reply\u201d.",

    errorGeneric: "Something went wrong",
    errorNoMessage: "Paste an incoming message first.",
    errorNoKey: "Missing OpenRouter API key (Settings or backend .env).",
    successCopied: "Reply copied to clipboard",

    footerNote:
      "Phase 1 · Supabase persistence · conversation memory · no auto-send",

    // Phase 2 — funnel
    funnelOverline: "FUNNEL / LINKDROP",
    funnelTitle: "Public landing page",
    funnelPublicUrl: "Public URL",
    funnelSlug: "Slug (URL path)",
    funnelSlugHint:
      "Lowercase, digits, dash, underscore. e.g. \u201cella\u201d → your public page is /f/ella.",
    funnelDisplayName: "Display name",
    funnelBio: "Bio",
    funnelBioPh: "A short one-or-two sentence intro...",
    funnelAvatar: "Avatar URL (optional)",
    funnelSaveProfile: "Save profile",
    funnelAnalytics: "Clicks",
    funnelTotal: "Total",
    funnelLast7: "7 days",
    funnelLast30: "30 days",
    funnelLinks: "Links",
    funnelAddLink: "Add link",
    funnelLinkTitlePh: "Fanvue, Telegram, Instagram, ...",
    funnelLinksEmpty:
      "No links yet. Add Fanvue, Telegram or Instagram.",
    funnelClicksLabel: "clicks",
    funnelSlugRequired: "Slug is required.",
    funnelLinkRequired: "Title and URL are required.",
    funnelProfileSaved: "Profile saved",
    funnelLinkCreated: "Link added",
    funnelUrlCopied: "URL copied",
    inactive: "Hidden",
    hide: "Hide",
    show: "Show",
    saving: "Saving...",
    setAsAiFunnel: "Use as AI funnel link",
    aiFunnelSet: "Set as AI funnel link",

    // Phase 4 — registration + soft gate
    authNoAccount: "Don't have an account?",
    registerOverline: "REGISTER",
    registerTitle: "Create your account",
    registerSubtitle: "Public registration · admin-approved",
    registerName: "Name",
    registerReason: "Why do you want access?",
    registerReasonPh: "Tell us in a few sentences why you'd like access...",
    registerSubmit: "Register",
    registerAlreadyHave: "Already have an account?",
    registerFillAll: "Please fill in all fields.",
    registerPwShort: "Password must be at least 8 characters.",
    registerSuccess: "Registration received",
    registerDoneTitle: "Thanks! Registration received.",
    registerDoneBody:
      "Account created and now waiting for admin approval. You can sign in immediately, but features will be locked until an admin approves you.",
    registerGotoLogin: "Go to sign in",
    pendingBannerTitle: "Account pending approval",
    pendingBannerBody:
      "Your account is pending admin approval. Features are locked in the meantime. We'll notify you as soon as an admin approves.",
    bannedBannerTitle: "Account banned",
    bannedBannerBody: "Access has been denied.",

    // Phase 3 — persona v2
    aboutMe: "About me",
    aboutMePh: "Your name, age, what you do, what you like...",
    aboutMeHint:
      "AI uses these facts when someone asks a personal question. Never invents anything beyond this.",
    ageLabel: "Age (optional)",
    boundariesLabel: "Boundaries (things you NEVER do)",
    boundariesPh: "e.g. never send nudes, never discuss medical topics...",
    transitionLabel: "Transition line (how to lead into the link)",
    transitionPh:
      "One-sentence teaser — AI rewrites it naturally right before the link.",

    // Rules engine
    rulesOverline: "FUNNEL RULES",
    rulesTitle: "When AI offers the link",
    ruleMinMessages: "Min. messages before link",
    ruleHeatThreshold: "Heat threshold (0–100)",
    ruleCooldown: "Cooldown (message count)",
    ruleIntentTriggers: "Intent triggers (comma-sep)",
    ruleIntentTriggersPh: "nudes, private, content, pay, OF",

    // Reply settings
    replyOverline: "REPLY STYLE",
    replyTitleSection: "Reply controls",
    toneIntensity: "Tone intensity",
    toneSubtle: "Subtle",
    toneBalanced: "Balanced",
    toneBold: "Bold",
    replyLength: "Reply length",
    lenShort: "Short",
    lenMedium: "Medium",
    lenLong: "Long",
    emojiLevel: "Emoji",
    emojiNone: "None",
    emojiLight: "Light",
    emojiModerate: "Moderate",
    languageMode: "Reply language",
    langMirror: "Mirror incoming",
    langForceSk: "Always SK",
    langForceEn: "Always EN",

    // Image upload
    imageAttach: "Attach image (optional)",
    imageAttachHint:
      "If he sends you a photo, AI can see it. Never produces explicit content. Blocks the request outright if the image involves a minor in any sexual context.",
    imageAttachBtn: "Choose image",
    imageRemove: "Remove image",
    imageAttached: "Image attached",
    imageBlockedTitle: "Safety block",
    imageBlockedBody:
      "Request was blocked by the safety guardrail. Nothing was generated.",
    imageNoteLabel: "Image note",
    linkIncluded: "Link included",
    linkNotIncluded: "Link NOT included",
  },
};

export const useT = (lang) => (key) => (STRINGS[lang] || STRINGS.en)[key] || key;
